import { render, staticRenderFns } from "./sectionTable.vue?vue&type=template&id=515c73f3&"
import script from "./sectionTable.vue?vue&type=script&lang=ts&"
export * from "./sectionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports